<template>
  <div :class="cssClass">
    <div v-if="isActive" class="l-notifications-top__content">
      <Icon2 variant="attention" :size="22" />
      <div class="l-notifications-top__summary">
        <p v-html="item.summary"></p>
      </div>
      <div
        v-if="item.description || item.url"
        class="l-notifications-top__btns"
      >
        <Button
          v-if="item.url"
          :href="item.url"
          target="_blank"
          variant="light"
          size="w110"
          fsize="f12"
        >
          詳しくはこちら
        </Button>
        <Button
          v-else-if="item.description"
          variant="light"
          size="w110"
          fsize="f12"
          @click="openModal"
        >
          詳しくはこちら
        </Button>
      </div>
    </div>
    <Button class="l-notifications-top__toggle" @click="toggle">
      <Icon variant="arrow_u-type02" :size="12" />
    </Button>
    <Modal
      v-if="isOpenModal && item.description && !item.url"
      variant="info"
      @close="closeModal"
    >
      <template slot="lead">
        <span v-html="item.summary"></span>
      </template>
      <template slot="content">
        <div v-html="item.description" class="c-text--free"></div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Button from '@/components/Button';
import Icon from '@/components/Icon';
import Icon2 from '@/components/Icon2';
import Modal from '@/components/Modal';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  components: {
    Button,
    Icon,
    Icon2,
    Modal
  },

  data() {
    return {
      isActive: true,
      isOpenModal: false
    };
  },

  computed: {
    cssClass() {
      return {
        'l-notifications-top__item': true,
        ['l-notifications-top__item--' + this.item.level]: this.item.level,
        'is-active': this.isActive
      };
    }
  },

  methods: {
    closeModal() {
      this.isOpenModal = false;
    },
    openModal() {
      this.isOpenModal = true;
    },
    toggle() {
      this.isActive = !this.isActive;
      this.$emit('toggle');
    }
  }
};
</script>
